import FindAtmScreen from 'features/moveMoney/screens/findAtm/FindAtmScreen';
import React from 'react';

export default function Page() {
  return <FindAtmScreen />;
}
